export default "/images/brand_logo.png?c77aff19bcd1d22cef86b3eb70e74e96";